/* LEMEIN - a REAL crossfade when the colourway changes.

   Prestige swaps colourways by toggling [hidden] on .product-gallery__media. The outgoing
   image is therefore removed in the same frame the incoming one appears, so fading the new
   image in on its own just shows the page background in between - it looks like a flash,
   not a dissolve.

   This holds a fixed-position snapshot of the OUTGOING mockup over the gallery and fades
   that out, while the incoming mockup is already fully opaque underneath. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var FADE_MS = 380;

  function firstVisible(gallery) {
    var media = gallery.querySelectorAll(".product-gallery__media");
    for (var i = 0; i < media.length; i++) {
      if (!media[i].hasAttribute("hidden")) return media[i];
    }
    return null;
  }

  function snapshot(el) {
    var img = el.querySelector("img");
    if (!img || !img.currentSrc) return null;
    var rect = img.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return null;
    return { src: img.currentSrc, rect: rect };
  }

  function crossfade(shot) {
    var ghost = document.createElement("img");
    ghost.className = "lm-xfade";
    ghost.src = shot.src;
    ghost.alt = "";
    ghost.setAttribute("aria-hidden", "true");
    ghost.style.left = shot.rect.left + "px";
    ghost.style.top = shot.rect.top + "px";
    ghost.style.width = shot.rect.width + "px";
    ghost.style.height = shot.rect.height + "px";
    document.body.appendChild(ghost);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { ghost.classList.add("is-out"); });
    });

    setTimeout(function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
    }, FADE_MS + 120);
  }

  function watch(gallery) {
    var current = firstVisible(gallery);
    var pending = current ? snapshot(current) : null;

    var observer = new MutationObserver(function () {
      var next = firstVisible(gallery);
      if (next && next !== current) {
        if (pending) crossfade(pending);
        current = next;
      } else if (next) {
        current = next;
      }
      pending = current ? snapshot(current) : null;
    });

    observer.observe(gallery, { attributes: true, attributeFilter: ["hidden"], subtree: true });

    /* keep a hard reference - an unreferenced MutationObserver can be collected */
    gallery.__lmObserver = observer;
  }

  function init() {
    var galleries = document.querySelectorAll(".product-gallery");
    for (var i = 0; i < galleries.length; i++) {
      if (!galleries[i].__lmObserver) watch(galleries[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
